<template>
  <div class="find-vacancy-q-pagination">
    <div class="find-vacancy-q-pagination__mob  d-none  d-xs-block">
      {{ $tFindVacancy('Question') }} <b>{{ currentStep + 1 }} из {{ steps.length }}</b>
    </div>
    <div v-for="(step, index) in steps"
         :key="getKey(step, index)"
         :class="{
           '_active': isActiveStep(index),
           '_active-last': isActiveLastStep(index),
         }"
         class="find-vacancy-q-pagination__step   d-xs-none">
      {{ index + 1 }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FindVacancyQPagePagination',
    props: {
      steps: Array,
      currentStep: Number,
      activeSteps: [Array, Object],
    },
    methods: {
      getKey(step, index) {
        return step?.id ?? index;
      },
      isActiveStep(index) {
        if (!this.activeSteps || typeof this.activeSteps[index] !== 'boolean') return this.currentStep >= index;
        return this.activeSteps[index]
      },
      isActiveLastStep(index) {
        if (!this.activeSteps || typeof this.activeSteps[index] !== 'boolean') return this.currentStep === index;
        return this.activeSteps[index]
      },
    },
  }
</script>

<style lang="less">

</style>
